import styled from 'styled-components';

export const Wrapper = styled.div<{ $grainIntensity: number }>`
  display: flex;
  flex: 1;
  position: relative;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  flex-direction: row;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 100 100"><filter id="noise"><feTurbulence type="fractalNoise" baseFrequency="2.5" numOctaves="3" stitchTiles="stitch"/></filter><rect width="100%" height="100%" filter="url(%23noise)" opacity="0.35"/></svg>');
    opacity: ${({ $grainIntensity }) => $grainIntensity};
    pointer-events: none;
    z-index: 1;
  }

  canvas {
  }
`;

export const Overlay = styled.div`
  position: absolute;
  width: 50px;
  left: calc(100vw - 523px);
  top: 125px;
  bottom: 0;
  background-color: transparent;
  z-index: 1;
`;

export const Main = styled.div`
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  padding-left: 200px;
  padding-right: 240px;
  width: 1100px;
  pointer-events: none;
`;

export const Center = styled.div`
  position: absolute;
  top: 20px;
  left: 20px;
  right: 280px;
  bottom: 70px;
  display: flex;

  @media (max-width: 768px) {
    max-height: 70vh;
  }
`;

export const Content = styled.div`
  flex: 1;
  display: flex;
`;

export const Right = styled.div`
  width: 260px;
  border-left: 2px solid #445;

  @media (max-width: 768px) {
    display: none;
  }
`;
